var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("header", [
        _c(
          "nav",
          {
            staticClass:
              "navbar navbar-expand-lg fixed-top navbar-dark bg-default navbar-center",
          },
          [
            _c("span", { staticClass: "navbar-brand", attrs: { href: "#" } }, [
              _vm._v(_vm._s(_vm.title)),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "main",
        {
          staticClass: "pb-3",
          class: { "with-footer": _vm.footerEnabled },
          attrs: { role: "main" },
        },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _c("loading", { attrs: { loading: _vm.loading } }),
      _vm._v(" "),
      _c("notifications", {
        attrs: {
          group: "error",
          position: "top center",
          duration: 10000,
          speed: 300,
          width: "350",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (props) {
              return [
                _c(
                  "div",
                  {
                    staticClass:
                      "alert alert-danger alert-dismissible fade show",
                    attrs: { role: "alert" },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(props.item.text) +
                        "\n                "
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "close",
                        attrs: {
                          type: "button",
                          "data-dismiss": "alert",
                          "aria-label": "Close",
                        },
                      },
                      [
                        _c("span", { attrs: { "aria-hidden": "true" } }, [
                          _vm._v("×"),
                        ]),
                      ]
                    ),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c("notifications", {
        attrs: {
          group: "general",
          position: "top right",
          duration: 3000,
          speed: 300,
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (props) {
              return [
                _c(
                  "div",
                  {
                    class:
                      "alert alert-" +
                      props.item.type +
                      " alert-dismissible fade show",
                    attrs: { role: "alert" },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(props.item.text) +
                        "\n                "
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "close",
                        attrs: {
                          type: "button",
                          "data-dismiss": "alert",
                          "aria-label": "Close",
                        },
                      },
                      [
                        _c("span", { attrs: { "aria-hidden": "true" } }, [
                          _vm._v("×"),
                        ]),
                      ]
                    ),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _vm.footerEnabled ? _c("my-footer", [_vm._t("footer")], 2) : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }